// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import HeaderClickable, { HeaderClickableStyles } from "@vanmeter/App/Components/Header/HeaderClickable";
import xIconsObject from "@vanmeter/XDL/Icons/xngCommonIcons";
import React from "react";

export interface HeaderMyListsStyles {
    headerClickable?: HeaderClickableStyles;
}

export const headerMyListsStyles: HeaderMyListsStyles = {};

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const styles = headerMyListsStyles;

export const HeaderClickableWidget = ({ fields }: Props) => {
    const link = useGetLink(fields.link);

    return (
        <HeaderClickable
            aria-label={fields.title}
            extendedStyles={styles.headerClickable}
            showIcon
            href={link.url}
            icon={{
                src: xIconsObject[fields.icon],
            }}
            hideOnTablet={fields.hideOnTablet}
        >
            {fields.label}
        </HeaderClickable>
    );
};

const widgetModule: WidgetModule = {
    component: HeaderClickableWidget,
    definition: {
        displayName: "Header Clickable",
        fieldDefinitions: [
            {
                displayName: "Label",
                name: "label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                displayName: "Destination",
                name: "link",
                editorTemplate: "LinkField",
                defaultValue: {
                    type: "Url",
                    value: "",
                },
                fieldType: "General",
            },
            {
                displayName: "Hide on Tablet",
                name: "hideOnTablet",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: "icon",
                displayName: "Icon",
                editorTemplate: "IconField" as any,
                defaultValue: "",
                fieldType: "General",
            },
        ],
        group: "Header",
    },
};

export default widgetModule;
